export const STATUS_MAP: Record<string, string> = {
  '0': 'Chưa ghi sổ',
  '3': 'Chờ duyệt',
  '5': 'Đã ghi sổ'
};

export const HOA_DON_MUA_HANG_TRONG_NUOC_EXPORT_TITLE = 'HÓA ĐƠN MUA HÀNG TRONG NƯỚC';
export const HOA_DON_MUA_HANG_TRONG_NUOC_SHEET_NAME = 'HoaDonMuaHangTrongNuoc';
export const HOA_DON_MUA_HANG_TRONG_NUOC_FILE_NAME = 'Hóa đơn mua hàng trong nước';
